export function isBookingFormInputField(field) {
    return field.type !== "section_header" && field.type !== "unknown";
}
